/* eslint-disable no-magic-numbers */
import PropTypes from "prop-types";

const VersionTag = ({
  release = false,
  version = "unknown",
  branch = null,
}) => {
  if (release) {
    return (
      <span className="tag is-info">
        <tt>{version}</tt>
      </span>
    );
  }
  const tagClass = /^(unknown|dev)$/.test(version) ? "danger" : "warning";
  if (branch && branch !== "master") {
    return (
      <div className="tags has-addons">
        <span className="tag is-dark">
          <tt className="has-text-light">{branch[0]}</tt>
        </span>
        <span className={`tag is-${tagClass}`}>
          <tt>{version.slice(0,4)}</tt>
        </span>
      </div>
    );
  }
  return (
    <span className={`tag is-${tagClass}`}>
      <tt>{version}</tt>
    </span>
  );
};

VersionTag.propTypes = {
  branch: PropTypes.string,
  release: PropTypes.bool.isRequired,
  version: PropTypes.string.isRequired,
};

export default VersionTag;
